export default __webpack_public_path__ + "static/media/edwardBach.689d7f3a.jpg";